import { Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { SkillValuePointerCursor, SkillValuePointerDot } from "../style";

interface ICallGraphSectionProps {
	planCount: {
		startAt: string;
		endAt: string;
		count: number;
		maxCount: number;
	};
	monthCount: {
		startAt: string;
		endAt: string;
		count: number;
		maxCount: number;
	};
	getDashboardInfo: (id: string) => void;
	isFoodlens?: boolean;
}
const CallGraphSection: React.FC<ICallGraphSectionProps> = ({
	planCount,
	monthCount,
	getDashboardInfo,
	isFoodlens = true,
}) => {
	const { id } = useParams<{ id?: string }>();
	const [isRenewIconRotationDegree, setIsRenewIconRotationDegree] =
		React.useState<number>(0);
	const [isRenewIconClickable, setIsRenewIconClickable] = React.useState<boolean>(true);
	const getCurTitme = () => {
		const now: Date = new Date();
		// 년, 월, 일, 시, 분 가져오기
		const year: number = now.getFullYear();
		const month: string = String(now.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 1을 더하고 2자리로 패딩
		const day: string = String(now.getDate()).padStart(2, "0");
		const hours: string = String(now.getHours()).padStart(2, "0");
		const minutes: string = String(now.getMinutes()).padStart(2, "0");

		// 오전 또는 오후 판별
		const ampm: string = Number(hours) >= 12 ? "오후" : "오전";

		// 12시간 형식으로 시간 변환
		const formattedHours = String(Number(hours) % 12 || 12).padStart(2, "0");
		const formattedTime = `${year}년 ${month}월 ${day}일 ${ampm} ${formattedHours}시 ${minutes}분`;

		return formattedTime;
	};
	const [callCountRenewTime, setCallCountRenewTime] = React.useState<string>(
		getCurTitme(),
	);
	// 월별 Call Count 관련
	const monthCountStartDate = new Date(monthCount.startAt);
	const monthCountEndDate = new Date(monthCount.endAt);
	const monthMaxCount = monthCount.maxCount;
	const monthUseCount = monthCount.count;
	let monthCountUsageRate = null;
	switch (monthMaxCount) {
		case -1:
			monthCountUsageRate = 100;
			break;
		case 0:
			monthCountUsageRate = 0;
			break;
		default:
			monthCountUsageRate = (monthUseCount / monthMaxCount) * 100;
	}
	// 계약일 기준 Call Count 관련
	let planCountStartDate = null;
	let planCountEndDate = null;
	let planMaxCount = null;
	let planUseCount = null;
	let planCountUsageRate = null;
	if (planCount != null) {
		planCountStartDate = new Date(planCount.startAt);
		planCountEndDate = new Date(planCount.endAt);
		planMaxCount = planCount.maxCount;
		planUseCount = planCount.count;

		switch (planMaxCount) {
			case -1:
				planCountUsageRate = 100;
				break;
			case 0:
				planCountUsageRate = 0;
				break;
			default:
				planCountUsageRate = (planUseCount / planMaxCount) * 100;
		}
	}
	const onCallCountRenew = () => {
		if (isRenewIconClickable) {
			setIsRenewIconRotationDegree(isRenewIconRotationDegree + 360);
			setCallCountRenewTime(getCurTitme());
			setIsRenewIconClickable(false);
			if (id != null) {
				getDashboardInfo(id);
			}
			setTimeout(() => {
				setIsRenewIconClickable(true);
			}, 10000);
		}
	};
	const renewIconStyle = {
		transform: `rotate(${isRenewIconRotationDegree}deg)`,
		transition: "transform 0.5s ease",
	};
	return (
		<div style={{ margin: "3rem 0rem" }}>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<Typography
					sx={{
						color: "#545351",
						fontSize: "1.2rem",
						marginBottom: "1rem",
						fontWeight: 700,
					}}
				>
					{isFoodlens ? "FoodLens" : "CaloAI"}
				</Typography>
				<div
					style={{
						display: "flex",
						gap: "12px",
						alignItems: "center",
					}}
				>
					<div
						style={{
							fontSize: "14px",
							color: "#545351",
						}}
					>
						{callCountRenewTime}에 마지막으로 업데이트됨
					</div>
					<div
						style={{
							width: "34px",
							height: "34px",
							backgroundColor: "#eaeaea",
							padding: "5px",
							borderRadius: "4px",
							cursor: "pointer",
						}}
						onClick={() => onCallCountRenew()}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							style={renewIconStyle}
						>
							<g clipPath="url(#clip0_259_5255)">
								<path
									d="M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z"
									fill="#323232"
								/>
							</g>
							<defs>
								<clipPath id="clip0_259_5255">
									<rect width="24" height="24" fill="white" />
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
			</div>
			<div
				className="CallGraph__Container"
				style={{ border: "2px solid #E0E0E0", backgroundColor: "#FFFFFF" }}
			>
				<div className="CallGraph__ProgressBar" style={{ margin: "3rem 2rem" }}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							marginBottom: "1.5rem",
						}}
					>
						<span>사용량</span>
						<div style={{ display: "flex" }}>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									marginRight: "1rem",
								}}
							>
								<div
									style={{
										width: "10px",
										height: "10px",
										background:
											"linear-gradient(90deg, #fff838 0%, #f7993f 10.23%, #c2423b 17.23%, #200909 32.95%, #0b1429 49.05%, #172c58 71.78%, #3d7bf9 100%), #d9d9d9",
										borderRadius: "50%",
										marginBottom: "5px",
										marginRight: "0.5rem",
									}}
								/>
								<span>현재 사용량</span>
							</div>
							<div style={{ display: "flex", alignItems: "center" }}>
								<div
									style={{
										width: "10px",
										height: "10px",
										backgroundColor: "#E1E1E1",
										borderRadius: "50%",
										marginBottom: "5px",
										marginRight: "0.5rem",
									}}
								/>
								<span>남은 사용량</span>
							</div>
						</div>
					</div>
					<div
						className="skill__description"
						style={{
							display: "flex",
							justifyContent: "space-between",
							marginBottom: "0.5rem",
						}}
					>
						<span>Call 수 (월)</span>
						<span>
							{monthMaxCount >= 0
								? `총 ${monthMaxCount.toLocaleString()}`
								: "무제한"}
						</span>
					</div>
					<div
						className="skill__bar"
						style={{
							width: "100%",
							height: "1rem",
							backgroundColor: "#E1E1E1",
						}}
					>
						<div
							className="skill__value"
							style={{
								width: `${monthCountUsageRate}%`,
								height: "1rem",
								background:
									"linear-gradient(90deg, #fff838 0%, #f7993f 10.23%, #c2423b 17.23%, #200909 32.95%, #0b1429 49.05%, #172c58 71.78%, #3d7bf9 100%), #d9d9d9",
								display: "flex",
								justifyContent: "flex-end",
							}}
						>
							<div
								style={{
									position: "relative",
									top: "2.8rem",
									left: "1.0rem",
									display: "table",
									color: "white",
									backgroundColor: "#d91f15",
									borderRadius: "6px",
									padding: "3px 12px",
								}}
							>
								{monthUseCount.toLocaleString()}
							</div>
						</div>
						<SkillValuePointerCursor value={`${monthCountUsageRate}%`} />
						<SkillValuePointerDot value={`${monthCountUsageRate - 0.15}%`} />
					</div>
					<div
						style={{
							marginTop: "0.5rem",
							color: "#aaa",
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<div>{monthCountStartDate.toLocaleDateString()}</div>
						<div>{monthCountEndDate.toLocaleDateString()}</div>
					</div>
				</div>
				{/*  */}
				<div className="CallGraph__ProgressBar" style={{ margin: "4rem 2rem" }}>
					<div
						className="skill__description"
						style={{
							display: "flex",
							justifyContent: "space-between",
							marginBottom: "0.5rem",
						}}
					>
						<span>Call 수 (계약일 기준)</span>
						{planCount && planMaxCount && (
							<span>
								{planMaxCount >= 0
									? `총 ${planMaxCount.toLocaleString()}`
									: "무제한"}
							</span>
						)}
					</div>
					<div
						className="skill__bar"
						style={{
							width: "100%",
							height: "1rem",
							backgroundColor: "#E1E1E1",
						}}
					>
						{planCount != null &&
						planMaxCount != null &&
						planUseCount != null &&
						planCountUsageRate != null ? (
							<>
								<div
									className="skill__value"
									style={{
										width: `${planCountUsageRate}%`,
										height: "1rem",
										background:
											"linear-gradient(90deg, #fff838 0%, #f7993f 10.23%, #c2423b 17.23%, #200909 32.95%, #0b1429 49.05%, #172c58 71.78%, #3d7bf9 100%), #d9d9d9",
										display: "flex",
										justifyContent: "flex-end",
									}}
								>
									<div
										style={{
											position: "relative",
											top: "2.8rem",
											left: "1rem",
											display: "table",
											color: "white",
											backgroundColor: "#d91f15",
											borderRadius: "6px",
											padding: "3px 12px",
										}}
									>
										{planUseCount.toLocaleString()}
									</div>
								</div>
								<SkillValuePointerCursor
									value={`${planCountUsageRate}%`}
								/>
								<SkillValuePointerDot
									value={`${planCountUsageRate - 0.15}%`}
								/>
							</>
						) : (
							<></>
						)}
					</div>
					<div
						style={{
							marginTop: "0.5rem",
							color: "#aaa",
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<div>{planCountStartDate?.toLocaleDateString()}</div>
						<div>{planCountEndDate?.toLocaleDateString()}</div>
					</div>
				</div>
				{/*  */}
			</div>
		</div>
	);
};

export default CallGraphSection;
